import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import JobIcon from "../assets/images/job.svg";
import LocationIcon from "../assets/images/map-point.svg";
import ArrowRight2 from "../assets/images/arrow-right-2.svg";
import { GET_CAREERS } from "../api/constants";
const CareerList = ({ career_section }) => {
  const [job_listings, setListings] = React.useState([]);
  const section1 = career_section?.section_1;
  const getCareers = async () => {
    try {
      const url = GET_CAREERS;
      const res = await fetch(url);
      const data = await res.json();
      console.log(data);

      if (data?.status && Array.isArray(data.data)) {
        setListings(data.data);
      } else {
        setListings([]);
      }
    } catch (err) {
      console.error("error", err);
      setListings([]);
    }
  };

  useEffect(() => {
    getCareers();
  }, []);

  return (
    <section className="job-listings-section common-padding">
      <Container>
        <div className="common-header text-center">
          <h2 dangerouslySetInnerHTML={{ __html: section1?.title }} />
          <p dangerouslySetInnerHTML={{ __html: section1?.subtitle }} />
        </div>
        <Row>
          {job_listings.map((job) => (
            <Col sm={12} key={job.id}>
              <Link to={`/career/${job.id}`} state={job} className="job-card">
                <div className="job-info">
                  <h3 className="job-title">{job.job_title}</h3>
                  <div className="job-meta">
                    <div className="meta-item">
                      <div className="icon-wrapper briefcase">
                        <img src={JobIcon} alt="Job Type" />
                      </div>
                      <div>
                        <span className="meta-label">Job Type</span>
                        <span className="meta-value">{job.job_type}</span>
                      </div>
                    </div>
                    <div className="meta-item">
                      <div className="icon-wrapper location">
                        <img src={LocationIcon} alt="Location" />
                      </div>
                      <div>
                        <span className="meta-label">Location</span>
                        <span className="meta-value">{job.location}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="job-action">
                  <div className="custom-bttn style-3 primary ani-1">
                    Job Description
                    <img src={ArrowRight2} alt="Arrow Right" />
                  </div>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default CareerList;
